export default "__VITE_ASSET__B4peTt77__"